var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlinkedAppointmentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.558 5.58l1.547-1.546a3.438 3.438 0 014.861 4.861l-1.547 1.547M10.442 14.42l-1.547 1.546a3.438 3.438 0 11-4.861-4.861L5.58 9.558M7.348 5.58V3.814M5.58 7.348H3.814M14.42 12.652h1.767M12.652 14.42v1.767",
    stroke: "#FF2800",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgUnlinkedAppointmentIcon;